/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable prettier/prettier */
import getPostCodeRegex from './getPostCodeRegex';
import getCountryStates from './getCountryStates';
import { getDisplayFormat } from './getDisplayFormat';

export const fieldsConfig = (country) => {
  const displayFormat = getDisplayFormat(country).multilineFormat;
  const letters = displayFormat.split('');

  // eslint-disable-next-line array-callback-return
  const fields = letters.map((x) => {
    switch (x.toUpperCase()) {
      case 'A':
        return {
          id: 'street',
          name: 'street',
          type: 'street',
          label: 'labels.address.edit.street.label',
          apifield: 'street',
          promptText: 'labels.address.edit.street.prompt',
          optionalText: 'labels.address.edit.street.optional',
          hint: 'labels.address.edit.street.hint',
          validators: [
            {
              apifield: 'street',
              name: 'required',
              type: 'predefined',
              key: 'required',
              message:
                'labels.address.edit.street.validation.required',
            },
            {
              apifield: 'street',
              name: 'min',
              type: 'predefined',
              key: 'min',
              length: 3,
              message:
                'labels.address.edit.street.validation.required',
            },
            {
              apifield: 'street',
              name: 'max',
              type: 'predefined',
              key: 'max',
              length: 255,
              message:
                'labels.address.edit.street.validation.maxLength',
            },
          ],
        };

      case 'P': {
        // Use "Zip" label for US, "Postal Code" for other countries
        const postalCodeLabelKey =
          country === 'US'
            ? 'labels.address.edit.zip.label'
            : 'labels.address.edit.postalCode.label';
        return {
          id: 'postcode',
          name: 'postcode',
          type: 'postcode',
          label: postalCodeLabelKey,
          apifield: 'postcode',
          promptText: 'labels.address.edit.postalCode.prompt',
          optionalText: 'labels.address.edit.postalCode.optional',
          hint: 'labels.address.edit.postalCode.hint',
          validators: [
            {
              apifield: 'postcode',
              mask: getPostCodeRegex(country),
              type: 'mask',
              message:
                'labels.address.edit.postalCode.validation.invalidZip',
            },
            {
              apifield: 'postcode',
              name: 'required',
              type: 'predefined',
              key: 'required',
              message:
                'labels.address.edit.postalCode.validation.required',
            },
          ],
        };
      }

      case 'C':
        return {
          id: 'city',
          name: 'city',
          type: 'city',
          label: 'labels.address.edit.city.label',
          apifield: 'city',
          promptText: 'labels.address.edit.city.prompt',
          optionalText: 'labels.address.edit.city.optional',
          hint: 'labels.address.edit.city.hint',
          validators: [
            {
              apifield: 'city',
              name: 'required',
              type: 'predefined',
              key: 'required',
              message: 'labels.address.edit.city.validation.required',
            },
          ],
        };

      case 'S':
        return {
          id: 'state',
          name: 'state',
          type: 'state',
          label: 'labels.address.edit.state.label',
          apifield: 'state',
          promptText: 'labels.address.edit.state.prompt',
          optionalText: 'labels.address.edit.state.optional',
          hint: 'labels.address.edit.state.hint',
          validators: [
            {
              apifield: 'state',
              name: 'required',
              type: 'predefined',
              key: 'required',
              message:
                'labels.address.edit.state.validation.required',
            },
          ],
        };
    }
  });

  fields.push({
    id: 'isPO',
    name: 'isPO',
    type: '',
    label: 'labels.address.edit.isPO.label',
    promptText: 'undefined',
    optionalText: 'undefined',
    hint: 'undefined',
    validators: [],
  });

  return fields;
};

export const buildCountrySpecificConfig = (
  country,
  adminLevel = 1,
) => {
  const displayFormat = getDisplayFormat(country).multilineFormat;
  return {
    country,
    displayFormat,
    fields: fieldsConfig(country),
    addressAPIState: {
      addressAPIStateTypeId: `administrative_area_level_${adminLevel}`,
      addressAPIStateName: 'long_name',
    },
    countryStates: getCountryStates(country),
  };
};
